import React from 'react';
import { Grid } from '@visx/grid';
import { DateAxisBottom } from 'js/components/Charts/Elements/DateAxisBottom';
import { YearUnderlay } from 'js/components/Charts/Elements/YearUnderlay';

import styles from './CapabilityTrendsChart.module.scss';

function NoActivity({ width, height, margin, scaleX, scaleY, text = 'No data' }) {
  margin = { top: 10, right: 15, bottom: 15, left: 15, ...margin };
  const chartHeight = height - margin.top - margin.bottom;
  const chartWidth = width - margin.left - margin.right;

  return (
    <div className={styles['element-trends-chart']}>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <YearUnderlay height={chartHeight} xScale={scaleX} />
          <Grid
            className="chart-grid chart-neutral-line"
            height={chartHeight}
            width={chartWidth}
            rowTickValues={[0, 0.5, 1]}
            xScale={scaleX}
            yScale={scaleY}
            stroke="#526067"
            numTicksColumns={5}
          />
          <DateAxisBottom
            chartHeight={chartHeight}
            chartWidth={chartWidth}
            xScale={scaleX}
          />
          <rect
            width={chartWidth}
            height={chartHeight}
            className="bounding-box"
          />
        </g>
      </svg>
      <div className={styles['no-activity-text']}>{text}</div>
    </div>
  );
}

export default NoActivity;
